import { type ApiClientResponse, mediaModuleClient, mediaRoutes } from 'common/services';

export const mediaDelete = async ({ id }: { id: string }) =>
  mediaModuleClient.delete<unknown, ApiClientResponse<unknown>>(mediaRoutes.detail.delete(id));
